"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GiveColonyBonus = void 0;
const DeferredAction_1 = require("./DeferredAction");
const Multiset_1 = require("../utils/Multiset");
class GiveColonyBonus {
    constructor(player, colony) {
        this.player = player;
        this.colony = colony;
        this.priority = DeferredAction_1.Priority.DEFAULT;
        this.cb = () => { };
        this.waitingFor = new Multiset_1.Multiset();
    }
    execute() {
        if (this.colony.colonies.length === 0) {
            this.cb();
            return undefined;
        }
        for (const playerId of this.colony.colonies) {
            this.waitingFor.add(playerId);
        }
        for (const entry of this.waitingFor.entries()) {
            const playerId = entry[0];
            const bonusPlayer = this.player.game.getPlayerById(playerId);
            this.giveColonyBonus(bonusPlayer);
        }
        return undefined;
    }
    giveColonyBonus(player) {
        if (this.waitingFor.get(player.id) !== undefined && this.waitingFor.get(player.id) > 0) {
            this.waitingFor.subtract(player.id);
            const input = this.colony.giveColonyBonus(player, true);
            if (input !== undefined) {
                player.setWaitingFor(input, () => this.giveColonyBonus(player));
            }
            else {
                this.giveColonyBonus(player);
            }
        }
        else {
            this.waitingFor.remove(player.id);
            this.doneGettingBonus();
        }
    }
    doneGettingBonus() {
        if (this.waitingFor.entries().length === 0) {
            this.cb();
        }
    }
}
exports.GiveColonyBonus = GiveColonyBonus;
//# sourceMappingURL=GiveColonyBonus.js.map